import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSdCard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sd-card, memory-stick"><path d="M17.25 2.75H4.75V21.25H19.25V11L17.25 7.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.25 6.75V9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 6.75V9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSdCard;
